import React from "react";
import { Typography, Paragraph } from "@bca/ui-library";

/**
 * These values are not exported from the design system as a type, so re-declaring here
 */
export type MessageTextAlignType = "left" | "center" | "right";

export interface MessageIconProps {
  title: string;
  textAlign?: MessageTextAlignType;
}

const Message: React.FunctionComponent<MessageIconProps> = ({
  title,
  textAlign = "left",
  ...props
}) => {
  return (
    <div>
      <Typography variant="h4" mb={0} textAlign={textAlign} color="footer-blue">
        {title}
      </Typography>
      <Paragraph
        textAlign={textAlign}
        fontSize="18px"
        lineHeight="1.4"
        color="grey-blue"
        data-testid="message-paragraph"
      >
        {props.children}
      </Paragraph>
    </div>
  );
};

export default Message;
